import * as React from 'react';
import { Dialog } from 'primereact/dialog';
import { Button } from "primereact/button";
import ActiveIngredientService from '../../services/activeIngredientService';
import { DropdownModel } from "../../models/dropdownModel";
import { Dropdown } from 'primereact/dropdown';
import { IngredientSideEffectReactionModel } from "../../models/sideEffect";
import { AnatomicalSystemModel } from "../../models/sideEffect";
import { FrequencyOfReactionModel } from "../../models/sideEffect";
import { InputTextarea } from 'primereact/inputtextarea';

interface IProps {
  isVisible: boolean,
  cancelClick: any,
  okClick: any,
  currentSideEffectReaction: IngredientSideEffectReactionModel,
  isAnatomicalSystemDropdownDisabled: boolean,
  selectedLangId: number
}

interface IState {
  isLoading: boolean;
  error: any;
  currentSideEffectReaction: IngredientSideEffectReactionModel;
  frequencyOfReactionDropdown: Array<DropdownModel>;
  anatomicalSystemDropdown: Array<DropdownModel>;
}

class SideEffectReactionAddEditDialog extends React.Component<IProps, IState> {
  activeIngredientService = new ActiveIngredientService();

  constructor(props: IProps) {
    super(props);

    this.state = {
      isLoading: false,
      error: null,
      currentSideEffectReaction: this.props.currentSideEffectReaction,
      frequencyOfReactionDropdown: Array<DropdownModel>(0),
      anatomicalSystemDropdown: Array<DropdownModel>(0)
    }
  }
  componentDidMount() {
    this.initData();
  }

  //TODO: optimaze this with one get method probably, ask dancho first
  initData() {
    const frequencyOfReactionDropdown: Array<DropdownModel> = [{ label: 'Select', value: -1 }];
    const anatomicalSystemDropdown: Array<DropdownModel> = [{ label: 'Select', value: -1 }];

    this.activeIngredientService.getDropdownFrequencyOfReaction().then(
      (data: Array<DropdownModel>) => {
        this.setState({
          frequencyOfReactionDropdown: frequencyOfReactionDropdown.concat(data),
        });
      })
      .catch(error => {
        this.setState({
          //error
        });
      });

    this.activeIngredientService.getDropdownAnatomicalSystem().then(
      (data: Array<DropdownModel>) => {
        this.setState({
          anatomicalSystemDropdown: anatomicalSystemDropdown.concat(data),
          currentSideEffectReaction: this.props.currentSideEffectReaction
        });
      })
      .catch(error => {
        this.setState({
          //error
        });
      });
  }

  //Optimize this
  //TODO: BG and EN names ????
  handleOkButton = event => {
    event.preventDefault();

    let frequencyOfReactionItem = this.state.frequencyOfReactionDropdown.find(i => i.value === this.state.currentSideEffectReaction.frequencyOfReaction.frequencyOfReactionId);
    if (frequencyOfReactionItem) {
      this.state.currentSideEffectReaction.frequencyOfReaction.frequencyName = frequencyOfReactionItem.label;
    }

    let anatomicalSystemItem = this.state.anatomicalSystemDropdown.find(i => i.value === this.state.currentSideEffectReaction.anatomicalSystem.anatomicalSystemId);
    if (anatomicalSystemItem) {
      this.state.currentSideEffectReaction.anatomicalSystem.anatomicalSystemNameEN = anatomicalSystemItem.label;
      this.state.currentSideEffectReaction.anatomicalSystemId = anatomicalSystemItem.value;
    }

    this.props.okClick(this.state.currentSideEffectReaction);
  }

  handleCanselButton = () => {
    this.props.cancelClick();
  }

  handleSideEffectReactionChange = (key, value) => {
    const currentSideEffectReaction: IngredientSideEffectReactionModel = { ...this.state.currentSideEffectReaction };
    currentSideEffectReaction[key] = value;
    this.setState({ currentSideEffectReaction: { ...currentSideEffectReaction } });
  };

  handleAnatomicalSystemChange = (key, value) => {
    const currentSideEffectReaction: IngredientSideEffectReactionModel = { ...this.state.currentSideEffectReaction };
    const currentAnatomicalSystem: AnatomicalSystemModel = { ...this.state.currentSideEffectReaction.anatomicalSystem };
    currentAnatomicalSystem[key] = value;
    currentSideEffectReaction.anatomicalSystem = currentAnatomicalSystem;

    this.setState({ currentSideEffectReaction: { ...currentSideEffectReaction } });
  };

  handleFrequencyOfReactionChange = (key, value) => {
    let currentSideEffectReaction: IngredientSideEffectReactionModel = { ...this.state.currentSideEffectReaction };
    let currentFrequencyOfReaction: FrequencyOfReactionModel = { ...this.state.currentSideEffectReaction.frequencyOfReaction };
    currentFrequencyOfReaction[key] = value;
    currentSideEffectReaction.frequencyOfReaction = currentFrequencyOfReaction;

    this.setState({ currentSideEffectReaction: { ...currentSideEffectReaction } });
  };

  getValueContent = (key) => {
    let content = this.state.currentSideEffectReaction.ingredientSideEffectReactionContent.find(r => r.langId == this.props.selectedLangId)
    if (content && content[key]) {
      return content[key];
    }
    return '';
  }

  handleContentChange = (key, value) => {
    const reaction: IngredientSideEffectReactionModel = { ...this.state.currentSideEffectReaction };
    let content = reaction.ingredientSideEffectReactionContent.find(r => r.langId == this.props.selectedLangId);
    if (content) {
      content[key] = value;
    }
    this.setState({ currentSideEffectReaction: { ...reaction } });
  }

  render() {
    const { frequencyOfReactionDropdown, anatomicalSystemDropdown, currentSideEffectReaction } = this.state;

    return (
      <Dialog header="Side effect reaction" responsive={true} width="70%"
        modal={true}
        visible={this.props.isVisible}
        onHide={this.handleCanselButton}
        footer={
          <div>
            <Button label="Add" icon="pi pi-check" onClick={this.handleOkButton} className="p-button-raised" disabled={!currentSideEffectReaction ||
              !currentSideEffectReaction.anatomicalSystem || !currentSideEffectReaction.anatomicalSystem.anatomicalSystemId ||
              currentSideEffectReaction.anatomicalSystem.anatomicalSystemId <= 0 || !currentSideEffectReaction.frequencyOfReaction ||
              !currentSideEffectReaction.frequencyOfReaction.frequencyOfReactionId || currentSideEffectReaction.frequencyOfReaction.frequencyOfReactionId <= 0} />
            <Button label="Cancel" icon="pi pi-times" onClick={this.handleCanselButton} className="p-button-secondary p-button-raised" />
          </div>
        }>
        <div style={{ minHeight: '350px', maxHeight: '550px' }}>
          <div className="p-fluid p-grid">
            <div className="p-col-12 p-md-6">
              <label>Anatomical system or organ:</label>
              <Dropdown
                disabled={this.props.isAnatomicalSystemDropdownDisabled}
                value={(currentSideEffectReaction &&
                  currentSideEffectReaction.anatomicalSystem &&
                  currentSideEffectReaction.anatomicalSystem.anatomicalSystemId) ? currentSideEffectReaction.anatomicalSystem.anatomicalSystemId : -1}
                options={anatomicalSystemDropdown}
                onChange={(e) => this.handleAnatomicalSystemChange('anatomicalSystemId', e.value)}
                style={{ width: '100%' }}
                filter={true} filterPlaceholder="Search system or organ" filterBy="label,value" autoWidth={false}
              />
            </div>
            <div className="p-col-12 p-md-6">
              <label>Frequency of reaction:</label>
              <Dropdown
                value={currentSideEffectReaction &&
                  currentSideEffectReaction.frequencyOfReaction &&
                  currentSideEffectReaction.frequencyOfReaction.frequencyOfReactionId ? currentSideEffectReaction.frequencyOfReaction.frequencyOfReactionId : -1}
                options={frequencyOfReactionDropdown}
                onChange={(e) => this.handleFrequencyOfReactionChange('frequencyOfReactionId', e.value)}
                style={{ width: '100%' }}
              />
            </div>
            <div className="p-col-12 p-md-12">
              <label>Description:</label>
              <InputTextarea
                style={{ width: '100%', height: '120px' }}
                onChange={(e) => { this.handleContentChange('description', e.target['value']) }}
                value={this.getValueContent('description')}
              />
            </div>
          </div>
        </div>
      </Dialog >
    )
  }
}

export default SideEffectReactionAddEditDialog;